import { IAppState } from '../../redux';
import { EServiceId, IBetPosition } from '../../redux/reducers';
import { curry } from 'ramda';

export const selectBetPositionByServiceId = curry((serviceId: EServiceId, state: IAppState): IBetPosition | null => {
  const {
    betPosition: { positionByService },
  } = state;

  return positionByService[serviceId] || null;
});
